import api from './client';
import { SearchResponse } from '../types';

export async function search(query: string): Promise<SearchResponse> {
  const response = await api.get<SearchResponse>('/search', {
    params: { q: query },
  });
  return response.data;
}
